import {
  profile,
  changePassword,
  changeDisplayName,
  unlinkProvider,
  createPassword,
  uploadProfileImage,
  deleteProfileImage,
  changeEmailRequest,
  changeEmail,
  cancelChangeEmail
} from '../../api/profile'

import {
  GET_PROFILE,
  PROFILE_DATA,
  CHANGE_PASSWORD,
  CHANGE_DISPLAY_NAME,
  UNLINK_PROVIDER,
  CREATE_PASSWORD,
  UPLOAD_PROFILE_IMAGE,
  DELETE_PROFILE_IMAGE,
  CHANGE_EMAIL_REQUEST,
  CHANGE_EMAIL,
  CANCEL_CHANGE_EMAIL
} from './constant'
import { ProfileResponse, ChangeEmailRequest, ChangeEmailPayload } from '../../api/type'

import { ActionTree } from 'vuex'
import { ProfileState } from './types'
import { Response } from '@/store/api/type'

export const actions: ActionTree<ProfileState, any> = {
  async [GET_PROFILE]({ commit }, { access_token }) {
    try {
      const resp = await profile(access_token)
      const data = resp as Response
      const profileData = data.data as ProfileResponse
      commit(PROFILE_DATA, profileData)
      return
    } catch (e) {
      const baseURL = process.env.VUE_APP_FINNO_ENDPOINT
      location.replace(baseURL)
      return
    }
  },
  async [CHANGE_PASSWORD]({ commit }, password) {
    try {
      const resp = await changePassword('', password)
      return resp
    } catch (ex) {
      return ex
    }
  },
  async [CHANGE_DISPLAY_NAME]({ commit }, displayName) {
    try {
      const resp = await changeDisplayName(displayName)
      return resp
    } catch (ex) {
      return ex
    }
  },
  async [UNLINK_PROVIDER]({ commit }, provider) {
    try {
      return await unlinkProvider(provider)
    } catch (ex) {
      return ex
    }
  },
  async [CREATE_PASSWORD]({ commit }, password) {
    try {
      return await createPassword(password)
    } catch (ex) {
      return ex
    }
  },
  async [UPLOAD_PROFILE_IMAGE]({ commit }, form) {
    try {
      return await uploadProfileImage(form)
    } catch (ex) {
      return ex
    }
  },
  async [DELETE_PROFILE_IMAGE]({ commit }) {
    try {
      return await deleteProfileImage()
    } catch (ex) {
      return ex
    }
  },
  async [CHANGE_EMAIL_REQUEST]({ commit }, email: ChangeEmailRequest) {
    try {
      return await changeEmailRequest(email)
    } catch (ex) {
      return ex
    }
  },
  async [CHANGE_EMAIL]({ commit }, payload: ChangeEmailPayload) {
    try {
      return await changeEmail(payload)
    } catch (ex) {
      return ex
    }
  },
  async [CANCEL_CHANGE_EMAIL]({ commit }) {
    try {
      return await cancelChangeEmail()
    } catch (ex) {
      return ex
    }
  }
}
